// @ts-ignore
import React, { ReactNode, useEffect } from "react";

import { css } from "@compiled/react";
import { defineMessages, FormattedMessage } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { ufoEventRedirectToProduct } from "@/components/signup/utils";
import { Link } from "@/libraries/design/components";

import { useAnalyticsClient } from "../../../../../../../../analytics/wac-analytics/analytics-client";
import MainContainer from "../../components/main-container/main-container";
import { MessageContainerProps } from "../../components/styles";

const MessageContainer = css(MessageContainerProps);

const ParagraphStyles = css({
    marginBlockStart: "unset"
});

const ErrorView = () => {
    const signUpUrl = "https://www.atlassian.com/try/cloud/signup";
    const analyticsClient = useAnalyticsClient();
    const { createAnalyticsEvent } = useAnalyticsEvents();

    useEffect(() => {
        // Confirming analyticsClient is initialized before firing event
        analyticsClient &&
            createAnalyticsEvent({
                eventName: "errorPageViewed",
                eventComponent: "errorPage",
                event: "viewed"
            }).fire("signup");
    }, [analyticsClient, createAnalyticsEvent]);

    // SLO "bad event" for redirect into product
    useEffect(() => {
        ufoEventRedirectToProduct.failure({
            customData: {
                reactComponent: "ErrorView",
                analyticsEvent: "errored",
                redirectFrom: "confirmationPage"
            }
        });
    }, []);

    return (
        <MainContainer showHeader={false}>
            <svg width="164" height="218" fill="none" aria-hidden="true">
                <linearGradient
                    id="error-icon-gradient"
                    x1="133.86"
                    x2="-2.79"
                    y1="136.43"
                    y2="200.15"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#ffd740" />
                    <stop offset="1" stopColor="#ffab00" />
                </linearGradient>
                <path
                    fill="url(#error-icon-gradient)"
                    d="m94.8 80.2 66.4 115a15.1 15.1 0 0 1-13.1 22.8H15.2a15.1 15.1 0 0 1-13.1-22.8l66.4-115a15.099 15.099 0 0 1 26.3 0z"
                />
                <path
                    fill="#253858"
                    d="m87.2 163.7 2.9-44.3a9.3 9.3 0 0 0-9.2-9.8 9.086 9.086 0 0 0-6.695 2.908A9.094 9.094 0 0 0 71.8 119.4l2.8 44.3a6.402 6.402 0 0 0 6.3 5.9 6.303 6.303 0 0 0 6.3-5.9zM71.4 187.2a9.496 9.496 0 0 0 6.464 9.145 9.49 9.49 0 0 0 3.936.455 9.702 9.702 0 0 0 8.712-12.022A9.7 9.7 0 0 0 71.4 187.2z"
                />
                <path
                    fill="#ffc400"
                    d="M91.699 27.2 84.299.4a.602.602 0 0 0-1.2.1l-4.7 25.1-5.8-1.1a.601.601 0 0 0-.7.8l7.5 26.7a.6.6 0 0 0 1.1 0l4.7-25.1 5.8 1a.6.6 0 0 0 .7-.7z"
                />
                <path
                    fill="#ffab00"
                    d="m65.1 41.8-10.9-8.5c-.2-.2-.5 0-.4.3L59.4 45l-2.7 1.3c-.2.1-.2.3 0 .5l10.8 8.5c.2.2.6-.1.4-.3l-5.5-11.5 2.7-1.2c.1-.1.2-.4 0-.5z"
                />
                <path
                    fill="#344563"
                    d="M101.1 56.7h-.6a1.101 1.101 0 0 1-.3-1.2c-.2-.8-2.3-2.9-3.5-4.1-3-3.1-5-5-3.9-6.5s3.6-.3 7.4 1.7a40.9 40.9 0 0 0 4.4 2 21.651 21.651 0 0 0-3.3-3.6c-2.9-3-4.9-5-3.8-6.5s3.6-.2 7.4 1.7a40.9 40.9 0 0 0 4.4 2 26.43 26.43 0 0 0-3.3-3.6c-2.9-3-4.9-5-3.8-6.5s3.6-.2 7.3 1.7c1.6.8 4.2 2.1 5 2.1a.899.899 0 0 1 1.2 0 1.006 1.006 0 0 1 .445.637 1 1 0 0 1-.145.763c-1.1 1.5-3.6.2-7.4-1.7a27.633 27.633 0 0 0-4.4-2 46.328 46.328 0 0 0 3.2 3.6c3 3 5 5 3.9 6.5s-3.6.2-7.4-1.7a42.948 42.948 0 0 0-4.4-2.1 26.682 26.682 0 0 0 3.3 3.7c2.9 3 4.9 5 3.8 6.4s-3.6.3-7.3-1.7a41.794 41.794 0 0 0-4.5-2c.7 1 2.3 2.6 3.3 3.7 3 3 4.9 5 3.8 6.4a.904.904 0 0 1-.8.3z"
                />
                <path
                    fill="#5e6c84"
                    d="M106.7 71.1a1.097 1.097 0 0 1-.9-.5c-1-1.9-2.2-4.1-.9-5.3s3.3.2 5.5 1.7c.915.65 1.886 1.219 2.9 1.7a13.622 13.622 0 0 0-1.4-3.1c-1.3-2.3-2.5-4.4-1.2-5.6s3.4.2 5.5 1.6a11.79 11.79 0 0 0 3.1 1.8 1 1 0 1 1 1.3 1.5c-1.3 1.2-3.4-.2-5.5-1.6a19.352 19.352 0 0 0-2.9-1.7 13.087 13.087 0 0 0 1.4 3c1.3 2.3 2.5 4.5 1.2 5.7s-3.4-.2-5.5-1.7a15.8 15.8 0 0 0-3-1.7c.352.937.787 1.84 1.3 2.7a1.004 1.004 0 0 1-.4 1.3zM52.4 68.2l-.7-.2c-1.6-.7-1.2-3.1-.8-5.6.232-1.118.333-2.259.3-3.4a22.496 22.496 0 0 0-2.2 2.6c-1.5 2.1-2.9 4.1-4.6 3.4a1 1 0 0 1-.5-1.3.9.9 0 0 1 1.2-.6c.5-.2 1.6-1.8 2.3-2.7s3-4.1 4.6-3.4 1.3 3.1.9 5.7a14.802 14.802 0 0 0-.4 3.4c.83-.78 1.568-1.652 2.2-2.6 1.5-2.1 3-4.1 4.6-3.4s1.3 3.1.9 5.2a1 1 0 1 1-1.9-.3c.116-.962.183-1.93.2-2.9a11.9 11.9 0 0 0-2.2 2.6c-1.3 1.8-2.6 3.5-3.9 3.5z"
                />
            </svg>
            <div css={MessageContainer}>
                <h2>
                    <FormattedMessage {...ErrorView.messages.errorTitle} />
                </h2>
                <p css={ParagraphStyles}>
                    <FormattedMessage
                        {...ErrorView.messages.error}
                        values={{
                            signUpAgainLink: (text: ReactNode) => (
                                <Link
                                    text={text as unknown as string}
                                    type="inline"
                                    href={signUpUrl}
                                />
                            ),
                            contactSupportLink: (text: ReactNode) => (
                                <Link
                                    text={text as unknown as string}
                                    type="inline"
                                    href="https://support.atlassian.com/contact/"
                                />
                            )
                        }}
                    />
                </p>
            </div>
        </MainContainer>
    );
};

export default ErrorView;

ErrorView.messages = defineMessages({
    errorTitle: {
        id: "WacConfirmationPage.errorTitle",
        defaultMessage: "We're not sure what went wrong"
    },
    error: {
        id: "WacConfirmationPage.error",
        defaultMessage:
            "Try <signUpAgainLink>signing up again</signUpAgainLink>. If this keeps happening, <contactSupportLink>contact support.</contactSupportLink>"
    }
});
